'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import Button from '../Button/index.js';
import Switcher from '../Switcher/index.js';
import closeIcon from '../Dialog/deleteIcon.js';
import styles from '../JobAlert/JobAlert.module.scss.js';
import { IconDeleteGrey } from '../icons/index.js';
import Dialog from '../Dialog/index.js';
import JobTitle from '../JobAlert/JobTitle/index.js';
import JobLevel from '../JobAlert/JobLevel/index.js';
import JobAlertSelect from '../JobAlert/JobAlertSelect/index.js';
import NotificationBy from '../JobAlert/NotificationBy/index.js';
import Interval from '../JobAlert/Interval/index.js';
import { ESalaryPeriod, SalaryPeriodOptions, successCode, duplicatedJobAlert, TOTAL_MAX_JOB_ALERT_CODE, maxJobTitleLength } from '../JobAlert/constants.js';
import Toast, { showToast, TOAST_TYPE_ERROR } from '../Toast/index.js';
import { jobAlertService } from '../JobAlert/apiServices.js';
import { t } from '../Utils/helpers.js';
import IconLoading from '../icons/IconLoading.js';
import Input from '../Input/index.js';
import MailboxIcon from './mailboxIcon.js';
import { ELanguage } from '../Utils/constants.js';
import CompanyIndustry from '../CompanyIndustry/index.js';
import JobFunction from '../JobFunction/index.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import '../UploadResumeModal/type.js';
import InputSalary from '../InputSalary/index.js';
import MultipleRadio from '../MultipleRadio/index.js';

/**
 * Job Alert Modal Component
 *
 * @param props
 */
var JobAlert = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o = props.language, language = _o === void 0 ? 'vi' : _o, _p = props.isMobile, isMobile = _p === void 0 ? false : _p, _q = props.jobAlertInfo, jobAlertInfo = _q === void 0 ? null : _q, _r = props.jobLocationOptions, jobLocationOptions = _r === void 0 ? [] : _r, _s = props.jobIndustryOptions, jobIndustryOptions = _s === void 0 ? [] : _s, _t = props.jobFunctionOptions, jobFunctionOptions = _t === void 0 ? {
        parent: [],
        child: {}
    } : _t, _u = props.defaultData, defaultData = _u === void 0 ? {
        jobTitle: '',
        jobSalary: 0,
        jobLevel: [1],
        jobLocation: [24],
        jobCategory: [35],
        jobIndustry: [],
        jobFunction: [],
        userEmail: 'user@gmail.com',
        apiJobAlert: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts',
        apiJobAlertAnonymous: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0/job-alerts-anonymous',
        apiTokenAccess: 'ZGQwY2E0MDgzYjQ1N2EyNzI2ODgyNGVkZjU3ZjliMDUyMTM2N2FkNmYxYTQwOWJmNmEwNWEyYTMxZDc5ZjUyYQ',
        apiJobLevelList: 'https://ms.vietnamworks.com/meta/v1.0/job-levels',
        isAuthenticated: 0,
        userTotalJobAlert: 0,
        msBaseUrl: 'https://ms.vietnamworks.com'
    } : _u, onDeleteJobAlert = props.onDeleteJobAlert, onAddEditJobAlert = props.onAddEditJobAlert, _v = props.useGlobalToast, useGlobalToast = _v === void 0 ? false : _v;
    var tracking = useHog().tracking;
    var IS_AUTHENTICATED = defaultData.isAuthenticated === 1;
    var _w = useState(false), isModalOpen = _w[0], setIsModalOpen = _w[1];
    var _x = useState(IS_AUTHENTICATED), isLoggedIn = _x[0], setIsLoggedIn = _x[1];
    var _y = useState(false), isButtonOpen = _y[0], setIsButtonOpen = _y[1];
    // Job Alert info
    var defaultJobTitle = defaultData.jobTitle.substring(0, 100);
    var _z = useState(defaultJobTitle !== null && defaultJobTitle !== void 0 ? defaultJobTitle : ''), jobTitle = _z[0], setJobTitle = _z[1];
    var _0 = useState((_a = defaultData.jobSalary) !== null && _a !== void 0 ? _a : 0), jobSalary = _0[0], setJobSalary = _0[1];
    var _1 = useState((_b = defaultData.jobLevel) !== null && _b !== void 0 ? _b : []), jobLevel = _1[0], setJobLevel = _1[1];
    var _2 = useState((_c = defaultData.jobLocation) !== null && _c !== void 0 ? _c : []), jobLocation = _2[0], setJobLocation = _2[1];
    var jobCategory = (_d = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobCategory) !== null && _d !== void 0 ? _d : [];
    var _3 = useState((_e = defaultData === null || defaultData === void 0 ? void 0 : defaultData.jobFunction) !== null && _e !== void 0 ? _e : []), jobFunction = _3[0], setJobFunction = _3[1];
    var _4 = useState((_f = defaultData.jobIndustry) !== null && _f !== void 0 ? _f : []), jobIndustry = _4[0], setJobIndustry = _4[1];
    var _5 = useState((_g = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.isReceivedJobAlert) !== null && _g !== void 0 ? _g : true), isReceivedJobAlert = _5[0], setReceivedJobAlert = _5[1];
    var _6 = useState((_h = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobInterval) !== null && _h !== void 0 ? _h : 2), jobInterval = _6[0], setJobInterval = _6[1];
    var _7 = useState((_j = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobNotificationBy) !== null && _j !== void 0 ? _j : 1), jobNotificationBy = _7[0], setJobNotificationBy = _7[1];
    var _8 = useState((_k = defaultData === null || defaultData === void 0 ? void 0 : defaultData.userEmail) !== null && _k !== void 0 ? _k : ''), userEmail = _8[0], setUserEmail = _8[1];
    var _9 = useState(true), isEmailValid = _9[0], setEmailValid = _9[1];
    var _10 = useState((_l = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryCurrencyId) !== null && _l !== void 0 ? _l : 1), salaryCurrencyId = _10[0], setSalaryCurrencyId = _10[1];
    var _11 = useState((_m = jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.salaryPeriodId) !== null && _m !== void 0 ? _m : ESalaryPeriod.MONTHLY), salaryPeriodId = _11[0], setSalaryPeriodId = _11[1];
    // modal
    var _12 = useState(false), isShowLoading = _12[0], setShowLoading = _12[1];
    var _13 = useState(false), isDeleteConfirmOpen = _13[0], setDeleteConfirmOpen = _13[1];
    var _14 = useState(false), isAskCloseWithoutSave = _14[0], setAskCloseWithoutSaveOpen = _14[1];
    var _15 = useState(false), isFormChanged = _15[0], setIsFormChange = _15[1];
    var _16 = useState({
        jobTitle: true
    }), validateForm = _16[0], setValidateForm = _16[1];
    // job level list
    var _17 = useState([]), jobLevelList = _17[0], setJobLevelList = _17[1];
    var isEdit = (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== undefined && (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) !== null;
    useEffect(function () {
        // Do get Job Level
        var doGetJobLevelList = function () { return __awaiter(void 0, void 0, void 0, function () {
            var getJobLevelListRespone, returnJobLevelList_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (jobLevelList.length > 0) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, jobAlertService.getJobLevelList(defaultData.apiJobLevelList)];
                    case 1:
                        getJobLevelListRespone = _a.sent();
                        if (getJobLevelListRespone.data !== undefined &&
                            getJobLevelListRespone.data.relationships !== undefined &&
                            getJobLevelListRespone.data.relationships.data !== undefined) {
                            returnJobLevelList_1 = [];
                            getJobLevelListRespone.data.relationships.data.map(function (item) {
                                returnJobLevelList_1.push({
                                    id: item.id,
                                    text: language === 'en' ? item.attributes.nameEn : item.attributes.nameVi
                                });
                            });
                            setJobLevelList(returnJobLevelList_1);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var removeOverflowClass = function () {
            document.body.classList.remove('overflow-hidden');
            document.documentElement.classList.remove('overflow-hidden');
        };
        // lock scrolling on body
        if (isModalOpen) {
            document.body.classList.add('overflow-hidden');
            document.documentElement.classList.add('overflow-hidden');
            doGetJobLevelList();
        }
        else {
            removeOverflowClass();
        }
        // Component will unmount
        return function () {
            removeOverflowClass();
        };
    }, [isModalOpen, props]);
    var handleOnClickClose = function () {
        // check if any data new then show ask close popup,
        // if don't have anything new then just close main modal
        if (isFormChanged) {
            setAskCloseWithoutSaveOpen(true);
        }
        else {
            setIsModalOpen(false);
        }
    };
    var isFormValidate = function () {
        var result = true;
        var jobTitleValid = true;
        // check job title
        if (jobTitle === '' || jobTitle.length > maxJobTitleLength) {
            result = false;
            jobTitleValid = false;
        }
        setValidateForm({
            jobTitle: jobTitleValid
        });
        return result;
    };
    var handleOnChangeUserEmail = function (value) {
        setEmailValid(true);
        setUserEmail(value);
    };
    // const validateEmail = (email: string) => {
    //     const regExp = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/
    //     return regExp.test(String(email).toLowerCase())
    // }
    var handleOnClickSaveUserEmail = function () {
        // check email valid
        var isValid = false;
        if (userEmail.indexOf('@') > 0) {
            isValid = true;
            if (userEmail.indexOf('.') > 0) {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        if (isValid) {
            // Done input email for user who didn't log in
            setIsLoggedIn(true);
        }
        else {
            // only set valid false. No need to set true for better performance
            setEmailValid(false);
        }
    };
    var handleOnClickDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var jobAlertResult, isDeleted, deletedNotifyContent;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, jobAlertService.deleteJobAlert("".concat(defaultData.apiJobAlert).concat(jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId), "".concat(defaultData.apiTokenAccess))];
                case 1:
                    jobAlertResult = _b.sent();
                    isDeleted = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode) {
                        isDeleted = true;
                        // Hide confirm delete dialog
                        setDeleteConfirmOpen(false);
                        // close edit modal
                        setIsModalOpen(false);
                        deletedNotifyContent = t('Job alert "{0}" deleted', language);
                        showToast(t('Job alert deleted successfully', language), deletedNotifyContent.replace('{0}', defaultData === null || defaultData === void 0 ? void 0 : defaultData.jobTitle));
                    }
                    onDeleteJobAlert && onDeleteJobAlert(isDeleted);
                    return [3 /*break*/, 3];
                case 2:
                    _b.sent();
                    setDeleteConfirmOpen(false);
                    showToast(t('Job alert error', language), t("Can't delete this job alert", language), TOAST_TYPE_ERROR);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var postData, isAnonymous, apiUrl, jobAlertResult, isSuccess, notifyTitle, notifyContent, notifyTitle, notifyContent;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    postData = {
                        keyword: jobTitle,
                        salary_min: jobSalary,
                        job_level: jobLevel,
                        location: jobLocation,
                        industry: jobCategory,
                        status: isReceivedJobAlert ? 1 : 0,
                        period_type_id: jobInterval,
                        notification_by: jobNotificationBy,
                        user_email: userEmail,
                        language_id: language === 'en' ? 2 : 1,
                        company_industry: jobIndustry,
                        job_function: jobFunction.map(function (item) { return item.childrenIds[0]; }),
                        salaryPeriodId: salaryPeriodId,
                        salaryCurrencyId: salaryCurrencyId
                    };
                    // Check form valid
                    if (!isFormValidate())
                        return [2 /*return*/];
                    setShowLoading(true);
                    isAnonymous = false;
                    apiUrl = isEdit ? (defaultData.apiJobAlert || '') + (jobAlertInfo === null || jobAlertInfo === void 0 ? void 0 : jobAlertInfo.jobAlertId) : defaultData.apiJobAlert;
                    if (IS_AUTHENTICATED !== undefined && !IS_AUTHENTICATED) {
                        // If user is not logged in then using anonymous url
                        apiUrl = defaultData.apiJobAlertAnonymous;
                        postData.job_level_id = defaultData.jobLevel[0];
                        isAnonymous = true;
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, jobAlertService.createEditJobAlert(postData, isEdit, "".concat(apiUrl), "".concat(defaultData.apiTokenAccess), isAnonymous)];
                case 2:
                    jobAlertResult = _c.sent();
                    isSuccess = false;
                    if (((_a = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _a === void 0 ? void 0 : _a.code) === successCode || (jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        tracking({
                            eventName: 'js_job_management:job_alert_create',
                            properties: {
                                keyword: jobTitle,
                                frequencyId: jobInterval,
                                chanelId: jobNotificationBy,
                                isEnable: !!isReceivedJobAlert,
                                isAnonymous: isAnonymous
                            }
                        });
                    }
                    if (((_b = jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.meta) === null || _b === void 0 ? void 0 : _b.code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = t('Job alert created successfully', language);
                        notifyContent = t('Job alert "{0}" created', language);
                        if (isEdit) {
                            // show edit success
                            notifyTitle = t('Job alert updated successfully', language);
                            notifyContent = t('Job alert "{0}" updated', language);
                        }
                        showToast(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === successCode) {
                        isSuccess = true;
                        setIsModalOpen(false);
                        notifyTitle = t('Job alert created successfully', language);
                        notifyContent = t('Job alert "{0}" created', language);
                        showToast(notifyTitle, notifyContent.replace('{0}', jobTitle));
                    }
                    if ((jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === duplicatedJobAlert) {
                        isSuccess = false;
                        // show duplicate
                        showToast(t('Job alert error', language), t('You already created this job alert', language), TOAST_TYPE_ERROR);
                    }
                    if (defaultData.userTotalJobAlert === 10 || (jobAlertResult === null || jobAlertResult === void 0 ? void 0 : jobAlertResult.Code) === TOTAL_MAX_JOB_ALERT_CODE) {
                        isSuccess = false;
                        showToast(t('Job alert error', language), t('You already created 10 job alerts!', language), TOAST_TYPE_ERROR);
                    }
                    setShowLoading(false);
                    onAddEditJobAlert && onAddEditJobAlert(isSuccess);
                    return [3 /*break*/, 4];
                case 3:
                    _c.sent();
                    setShowLoading(false);
                    showToast(t('Job alert error', language), t("Can't update this job alert", language), TOAST_TYPE_ERROR);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleOnClickCloseAskSave = function () {
        setAskCloseWithoutSaveOpen(false);
        setIsModalOpen(false);
    };
    var isShowJobAlertModal = isModalOpen;
    if (isAskCloseWithoutSave) {
        isShowJobAlertModal = false;
    }
    if (isDeleteConfirmOpen) {
        isShowJobAlertModal = false;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "".concat(styles.wraperFloatingIcon, " ").concat(isButtonOpen ? styles.showBtn : ''), onMouseEnter: function () { return setIsButtonOpen(true); }, onMouseLeave: function () { return setIsButtonOpen(false); } },
            React__default.createElement("div", { className: 'd-flex' },
                React__default.createElement("span", { className: styles.mailBoxFloating },
                    React__default.createElement(MailboxIcon, null)),
                React__default.createElement("div", { className: styles.extendJobAlertIcon },
                    React__default.createElement("div", { className: styles.mailBoxText }, t('Receive job alerts for jobs like this search!', language)),
                    React__default.createElement(Button, { type: 'primary', onClick: function () { return setIsModalOpen(true); } }, t('Send me jobs', language))))),
        React__default.createElement("div", { className: styles.backdrop + ' ' + (isShowJobAlertModal ? styles.isOpen : ''), onClick: handleOnClickClose }),
        React__default.createElement("div", { className: 'box-dialog ' + styles.jobAlertModal + ' ' + (isShowJobAlertModal ? styles.isOpen : '') },
            React__default.createElement("div", { className: styles.overlayLock, style: { display: isShowLoading ? 'flex' : 'none' } },
                React__default.createElement(IconLoading, { width: 64, height: 64 })),
            React__default.createElement("div", { className: styles.header },
                React__default.createElement("div", { className: styles.modalTitle }, t('Create Job Alert', language)),
                React__default.createElement("span", { onClick: handleOnClickClose, className: "".concat(styles.icon, " ").concat(isMobile ? styles.left : styles.right) },
                    React__default.createElement(closeIcon, null))),
            isLoggedIn ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: styles.body },
                    React__default.createElement("div", { className: styles.row }, isMobile ? (React__default.createElement("div", { className: styles.colSmall12 },
                        React__default.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                setReceivedJobAlert(value);
                                if (value !== isReceivedJobAlert)
                                    setIsFormChange(true);
                            }, value: isReceivedJobAlert, label: t('Receive Job Alerts', language) }))) : (React__default.createElement("div", { className: styles.hideOnMobile }))),
                    React__default.createElement("div", { className: styles.row + ' ' + styles.mb0 },
                        React__default.createElement("div", { className: isMobile ? styles.colSmall6 : styles.row },
                            React__default.createElement(JobTitle, { key: "jobTitle-".concat(validateForm.jobTitle ? 'true' : 'false'), jobTitle: jobTitle, setJobTitle: function (value) {
                                    setJobTitle(value);
                                    if (value !== jobTitle)
                                        setIsFormChange(true);
                                }, isValidate: validateForm.jobTitle, language: language })),
                        React__default.createElement("div", { className: isMobile ? '' : styles.row },
                            React__default.createElement("div", { className: styles.colSmall6 + ' ' + styles.inputSalary },
                                React__default.createElement(InputSalary, { salary: jobSalary, currencyId: salaryCurrencyId, msBaseUrl: defaultData.msBaseUrl, langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN, options: {
                                        label: t('Salary from', language)
                                    }, onChange: function (value, currencyId) {
                                        setJobSalary(value);
                                        setSalaryCurrencyId(currencyId);
                                        if (value !== jobSalary)
                                            setIsFormChange(true);
                                    } })),
                            React__default.createElement("div", { className: styles.colSmall6 },
                                React__default.createElement("label", { htmlFor: 'jobSalary' }, t('Pay period', language)),
                                React__default.createElement(MultipleRadio, { name: 'currencyPeriod', value: salaryPeriodId, options: language === 'vi' ? SalaryPeriodOptions.vi : SalaryPeriodOptions.en, onChange: function (_a) {
                                        var value = _a.value;
                                        setSalaryPeriodId(value);
                                    } })))),
                    React__default.createElement("div", { className: styles.row },
                        React__default.createElement("div", { className: styles.colSmall6 },
                            React__default.createElement(JobLevel, { isMobile: isMobile, jobLevelOptions: jobLevelList, jobLevel: jobLevel, setJobLevel: function (value) {
                                    setJobLevel(value);
                                    if (value !== jobLevel)
                                        setIsFormChange(true);
                                }, limitCharacterShow: 120, limitMaxShowItem: 3, language: language === 'vi' ? ELanguage.VI : ELanguage.EN })),
                        React__default.createElement("div", { className: styles.colSmall6 },
                            React__default.createElement(JobAlertSelect, { isMobile: isMobile, jobSelectValue: jobLocation, setJobSelect: function (id) {
                                    setJobLocation(id);
                                    if (id !== jobLocation)
                                        setIsFormChange(true);
                                }, title: t('Location', language), jobOptions: jobLocationOptions, limitAlertText: t('You can only choose maximum 3 locations', language), errorText: t('This field is required', language), noResult: t('No result', language), pleaseSelect: t('Select location', language), limitCharacterShow: 120, customWidth: '100%', langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN }))),
                    React__default.createElement("div", { className: styles.row },
                        React__default.createElement("div", { className: styles.colSmall6 },
                            React__default.createElement("label", null, language === ELanguage.VI ? 'Ngành nghề' : 'Job function'),
                            React__default.createElement(JobFunction, { isMobile: isMobile, data: jobFunctionOptions, value: jobFunction, langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN, onChange: function (value) {
                                    setJobFunction(value);
                                    setIsFormChange(true);
                                }, dropdownStyleOptions: {
                                    width: '100%'
                                }, isFlex: true, isSingleSelect: true, displayAsPopup: true })),
                        React__default.createElement("div", { className: styles.colSmall6 },
                            React__default.createElement("label", { htmlFor: 'userEmail' }, language === ELanguage.VI ? 'Lĩnh vực công ty' : 'Industries'),
                            React__default.createElement(CompanyIndustry, { type: 'multiple-select', options: jobIndustryOptions, value: jobIndustry, onChange: function (ids) {
                                    setJobIndustry(ids);
                                    setIsFormChange(true);
                                }, langCode: language === 'vi' ? ELanguage.VI : ELanguage.EN, dropdownStyle: { width: '100%' }, isMobile: isMobile }))),
                    React__default.createElement("div", { className: styles.row },
                        React__default.createElement("div", { className: styles.colSmall6 },
                            React__default.createElement(Interval, { jobInterval: jobInterval, setJobInterval: function (value) {
                                    setJobInterval(value);
                                    if (value !== jobInterval)
                                        setIsFormChange(true);
                                }, language: language })),
                        React__default.createElement("div", { className: styles.colSmall6 },
                            React__default.createElement(NotificationBy, { jobNotificationBy: jobNotificationBy, setJobNotificationBy: function (value) {
                                    setJobNotificationBy(value);
                                    if (value !== jobNotificationBy)
                                        setIsFormChange(true);
                                }, language: language })))),
                React__default.createElement("div", { className: styles.footer },
                    React__default.createElement("div", { className: styles.row + ' ' + styles.flexCenter },
                        React__default.createElement("div", { className: styles.colSmall6 + ' ' + styles.alignMiddle + ' ' + styles.hideOnMobile }, isMobile ? (React__default.createElement("div", null)) : (React__default.createElement(Switcher, { key: "switcher-".concat(Math.random()), onChange: function (value) {
                                setReceivedJobAlert(value);
                                if (value !== isReceivedJobAlert)
                                    setIsFormChange(true);
                            }, value: isReceivedJobAlert, label: t('Receive Job Alerts', language) }))),
                        React__default.createElement("div", { className: "".concat(styles.colSmall6, " ").concat(styles.colBottomRight) },
                            isEdit ? (React__default.createElement("div", { className: styles.iconDelete, onClick: function () { return setDeleteConfirmOpen(true); } },
                                React__default.createElement(IconDeleteGrey, null))) : (React__default.createElement("div", null)),
                            React__default.createElement("div", null,
                                React__default.createElement(Button, { type: 'primary', style: { float: 'right' }, onClick: handleOnClickSave }, t('Save', language)),
                                React__default.createElement(Button, { style: { marginRight: 10 }, onClick: handleOnClickClose }, t('Cancel', language)))))))) : (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: styles.body },
                    React__default.createElement("div", { className: styles.row },
                        React__default.createElement("div", { className: styles.colSmall8 },
                            React__default.createElement("label", { htmlFor: 'userEmail' }, t('Your email', language)),
                            React__default.createElement(Input, { type: 'text', id: 'userEmail', isRequired: true, onChange: function (value) {
                                    handleOnChangeUserEmail(value);
                                }, onPressEnter: handleOnClickSaveUserEmail, value: userEmail, className: styles.jobAlertInput, maxLength: 100, placeholder: t('Email to receive jobs', language), autoFocus: true, hasError: !isEmailValid })),
                        isMobile ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement("div", { className: styles.colSmall4, style: { paddingLeft: 10 } },
                            React__default.createElement(Button, { type: 'primary', size: 'md', onClick: handleOnClickSaveUserEmail, style: { width: '100%' } }, t('Send me jobs', language))))),
                    React__default.createElement("div", __assign({ className: styles.row }, (isEmailValid ? { hidden: true } : '')),
                        React__default.createElement("p", __assign({ className: "error-message ".concat(styles.errorMessage) }, (isEmailValid ? { hidden: true } : '')), t('This is not a valid email address', language)))),
                isMobile ? (React__default.createElement("div", { className: styles.footer },
                    React__default.createElement("div", { className: styles.row + ' ' + styles.flexCenter },
                        React__default.createElement("div", { className: "".concat(styles.colSmall6, " ").concat(styles.colBottomRight) },
                            React__default.createElement("div", null,
                                React__default.createElement(Button, { type: 'primary', size: 'sm', onClick: handleOnClickSaveUserEmail, style: { float: 'right' } }, t('Send me jobs', language)),
                                React__default.createElement(Button, { size: 'sm', style: { marginRight: 10 }, onClick: handleOnClickClose }, t('Cancel', language))))))) : (React__default.createElement(React__default.Fragment, null))))),
        React__default.createElement(Dialog, { title: t('Delete this Job Alert?', language), isOpen: isDeleteConfirmOpen, onBack: function () { return setDeleteConfirmOpen(false); }, onClickAction: handleOnClickDelete, type: 'delete', deleteText: t('Remove', language), secondaryButtonText: t('Cancel', language), backdrop: true },
            React__default.createElement("div", null, t('You will not be able to receive email for job alert', language))),
        React__default.createElement(Dialog, { title: t('Discard this job alert?', language), isOpen: isAskCloseWithoutSave, onBack: function () { return setAskCloseWithoutSaveOpen(false); }, onClickAction: handleOnClickCloseAskSave, type: 'delete', deleteText: t('Yes', language), secondaryButtonText: t('No', language), backdrop: true },
            React__default.createElement("div", null, t('This job alert will not be saved', language))),
        !useGlobalToast && React__default.createElement(Toast, null)));
};

export { JobAlert as default };
//# sourceMappingURL=PopupUMD.js.map
